import { get } from 'lodash';

import app from '../app';
import materialTypes from '../enums/material-type-urban';

const events = {
  process: 'btiService.process',
};

app.factory('btiService', [
  'apiService',
  'categoryService',
  'addFormService',
  '$rootScope',
  '$log',
  (apiService, categoryService, addFormService, $rootScope, $log) => {
    const allowedMaterialTypes = materialTypes.map(item => item.key);

    const getHouseId = (address = []) => {
      const house = address.find(item => item.type === 'house');

      return house ? house.id : void 0;
    };

    const allowedCommercialCategories = [
      'office',
      'shoppingArea',
      'freeAppointmentObject',
      'warehouse',
      'industry',
      'building',
      'business',
    ];
    const isBtiCommercialCategory = (categoryStr = addFormService.ad.category) => {
      const { objectType } = categoryService.getInfoByCategory(categoryStr);

      if (addFormService.ad.coworkingOfferType) {
        return false;
      }

      return allowedCommercialCategories.indexOf(objectType) !== -1;
    };

    const isBtiCategory = (categoryStr = addFormService.ad.category) => {
      const { objectType } = categoryService.getInfoByCategory(categoryStr);
      // продажа или аренда квартиры, комнаты или койко-места
      const isObjectAllowed = ['flat', 'room', 'bed'].indexOf(objectType) !== -1;

      return isBtiCommercialCategory(categoryStr) || isObjectAllowed;
    };

    const address = get(window.addFormState, 'draft.geo.address');

    var latestBtiHouseId = getHouseId(address); // Последний обработанный дом
    var latestBtiData;
    /**
     * Сбрасываем свойства объекта ad, если значение свойства объекта ad
     * равно значению того же свойства из последних полученных данных БТИ
     */
    function flushBtiData() {
      if (latestBtiData) {
        addFormService.cleanFormIfEqual(latestBtiData);
      }
    }

    // Выводим полные данные из апи bti, без разреза по дому или подъезду.
    // Фильтр лифтов пассажирских/грузовых отображает не более 4-х
    const normalizeLiftsCount = apiCount => {
      return Number(apiCount) > 4 ? 4 : Number(apiCount);
    };

    /**
     * Заполняем объект ad, данными из БТИ.
     * В данных БТИ нет названия ЖК, его берем из данных ЖК, если они есть.
     */
    function fillBtiData(data, jkName) {
      latestBtiData = {
        'building.name': jkName,
        'building.hasGarbageChute': data.chute === true,
        'building.ceilingHeight': data.ceilingHeight,
        'building.buildYear': data.yearRelease,
        'building.series': data.series,
        'building.floorsCount': data.floorMax,
        'building.materialType': allowedMaterialTypes.includes(data.houseMaterialType)
          ? data.houseMaterialType
          : undefined,
        'building.passengerLiftsCount': normalizeLiftsCount(data.passengerLifts),
        'building.cargoLiftsCount': normalizeLiftsCount(data.serviceLifts),
      };

      if (data.floorMax) {
        latestBtiData.floorsCount = data.floorMax;
      }

      if (isBtiCommercialCategory()) {
        latestBtiData['building.statusType'] = 'operational';
        latestBtiData['building.type'] = 'residentialHouse';
      }

      addFormService.fillForm(latestBtiData);
    }

    const processBti = (ad, jkName) => {
      const houseId = getHouseId(ad.geo && ad.geo.address);
      flushBtiData();

      return apiService
        .getBtiBuildings(houseId)
        .then(data => {
          fillBtiData(data, jkName);
          latestBtiHouseId = houseId;
          triggerProcess(data);
        })
        .catch(() => {
          $log.debug(`Не найдены данные bti для дома: ${houseId}`);
        });
    };

    /**
     * подписаться на обработку данных БТИ
     * @param handler обработчик function(data){}
     * @return функция для отписки
     */
    const onProcess = handler => $rootScope.$on(events.process, (event, ...args) => handler(...args));
    const triggerProcess = data => $rootScope.$emit(events.process, data);

    const isBtiProcessed = () =>
      latestBtiHouseId && latestBtiHouseId === getHouseId(get(addFormService, 'ad.geo.address'));

    return {
      processBti,
      isBtiProcessed,
      isBtiCategory,
      isBtiCommercialCategory,
      onProcess,
    };
  },
]);
